import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { UserActions } from "../../../redux/actions/user.actions";
import { instructorActions } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Directions, translationConstants } from "../../../constants";

const DisableUser = ({ setShow, gridState, userData, isInstructor }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    if (isInstructor) {
      setUserInfo(userData.userInfo);
    } else {
      setUserInfo(userData);
    }
  }, [userData]);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onSubmit = (data) => {
    if (isInstructor) {
      dispatch(
        instructorActions.updateInstructorStatusWithCallback(
          {
            userId: userData.userInfo.id,
            comments: data.comment,
          },
          instructorActions.getAllInstructors(gridState)
        )
      );
    } else {
      dispatch(
        UserActions.updateUserStatusWithCallback(
          {
            userId: userData.id,
            comments: data.comment,
          },
          UserActions.getUsers(gridState)
        )
      );
    }
    setShow(false);
  };
  return (
    <Form className="approvalCertificateDiv" onSubmit={handleSubmit(onSubmit)}>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {isInstructor
            ? t(translationConstants.DISABLE_INSTRUCTOR)
            : t(translationConstants.DISABLE_USER)}
        </p>
      </div>
      <p className="horizentalLine"></p>

      <div className="py-3">
        {t(translationConstants.YOU_ARE_GOING_TO_DISABLE_USER)}{" "}
        <span className="fw-800">
          {direction === Directions.rtl && userInfo?.arabicName
            ? `${userInfo?.arabicFirstName + " " + userInfo?.arabicLastName}`
            : `${
                userInfo?.englishFirstName + " " + userInfo?.englishLastName
              }`}{" "}
        </span>
        ,{t(translationConstants.PLEASE_COMMENT_DOWN_A_REASON_BELOW)}{" "}
      </div>

      <Form.Group className="form-group formgroupTextarea">
        <Form.Label className="Form-labels">
          {t(translationConstants.REASON)}
        </Form.Label>
        <textarea
          className="commentInput"
          {...register("comment", {
            required: t(translationConstants.commentRequired), // Add a required validation rule and define the translation key
          })}
          id="comment"
          type="text"
        />
        {errors.comment && (
          <p className="errorText">{errors.comment.message}</p>
        )}
      </Form.Group>

      <button className="rejected-button" type="submit">
        {t(translationConstants.DISABLE)}
      </button>
    </Form>
  );
};

export default DisableUser;
